import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { STDStyle, Buttons, BoxInput } from '../style';
import Std from '../../stdPages/std';
import Text from '@/components/Text';
import * as w from '@/helpers_site/textsSite';
import Button from '@/components/Button';
import ButtonBack from '@/components/ButtonBack';
import axios from 'axios';
import InputText from '@/components/InputText';


const Unsub = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [confirm, setConfirm] = useState(false);
  const [titleText, setTitleText] = useState("");

  const rid = searchParams.get("xce8y");

  const qrValue = useMemo(() => {
    if (!rid) return "";  
    return rid;
  }, [rid]);

  const onSubmitUnsubscribe = async () => {
   
    console.log(qrValue)
    if (!qrValue) return;
   
    try {
      const response = await api.post(
        `${process.env.URL_SITE_WWW}/x7a9/p/emails/sent-unsubscribe`,
        { token_unsub: qrValue },
        {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(response)
      if (response?.data?.status === "ok") {
        setTitleText(w.confirmUnsub);  // textResponse vem do seu contexto
        setConfirm(true);
      } else {
        setTitleText(w.errorApollo);
        setConfirm(false);
        console.log(err)
      }
    } catch (err) {
      // Se der erro HTTP (4xx/5xx) ou rede, cai aqui
      setTitleText(w.errorApollo);
      setConfirm(false);
    }
  };
  
  if (!rid) return null

  return (
    <Std id='front' withoutMenu={true}>
      <STDStyle>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '50px', maxWidth: '600px' }} >
          {!confirm ?
            <>
              <Text title={w.UnsubTitle} $family='head' color={'rgb(0,14,38)'} typeFont='head' tag='h3' />
              <Text title={w.UnsubText} $family='head' color={'rgb(0,14,38)'} typeFont='head' tag='h3Small' />
              <BoxInput>
                <Buttons>
                  <Button handle={onSubmitUnsubscribe} text="Continuar" />
                </Buttons>
              </BoxInput>
            </>
            :
            <Text title={titleText} $family='head' color={'rgb(0,14,38)'} typeFont='head' tag='h3' />
          }
        </div>
      </STDStyle>
    </Std>
  );
};

export default Unsub;
